// extracted by mini-css-extract-plugin
export default {"filtersGroup":"people_filtersGroup__atSyC"};